module.exports = __webpack_public_path__ + "img/152.5441acb5.png";